import { combineReducers } from "redux"
// import customerReducer from "./features/customer/customerSlice";
import cartReducer from "../features/cart/cartSlice"
export default combineReducers({
  // customer: customerReducer,
  cart: cartReducer,
})
